import { useCallback } from 'react';

import { ListEntityType } from 'src/services/lists/lists.types';
import { CsvImportRow, CsvImportOptions } from 'src/services/common.types';
import { CustomFieldEntityType } from 'src/services/custom-fields/custom-field.types';
import { useBulkContactImportMutation } from 'src/services/contacts/contacts.service';

import CsvImportDialog, { CsvImportResult } from 'src/sections/import/csv-import-dialog';

type Props = {
  organizationId?: string | undefined;
  open: boolean;
  onClose: VoidFunction;
};

const resultLabel = (result: CsvImportResult) => result.email ?? '';

export default function BulkContactUploadModal({ organizationId, open, onClose }: Props) {
  const [bulkContactImport, { isLoading }] = useBulkContactImportMutation();

  const handleImport = useCallback(
    (rows: CsvImportRow[], options: CsvImportOptions) =>
      bulkContactImport({ data: { organization_id: organizationId, contacts: rows, ...options } }).unwrap(),
    [bulkContactImport, organizationId]
  );

  return (
    <CsvImportDialog
      open={open}
      onClose={onClose}
      organizationId={organizationId}
      entity="contact"
      customFieldEntityType={CustomFieldEntityType.CONTACT}
      listEntityType={ListEntityType.CONTACT}
      i18nPrefix="contacts.bulk_import_modal"
      templateFileName="Contact Import Template.csv"
      isImporting={isLoading}
      onImport={handleImport}
      resultLabel={resultLabel}
      showCompanyColumn
    />
  );
}
